import { Box, Button, ButtonProps, Center, Container, Text, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure, Flex, Spacer } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "../../components/table";
import Layout from "../layouts";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../../components/loading-screen";
import AuthorService from "../../services/authors/author-service";

const AuthorScene = (): ReactElement => {
    const navigate = useNavigate();
    const [authors, setAuthors] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);

        AuthorService.GetAll().then((res: any) => {
            if (res.result) {
                setAuthors(res.result);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    const handleClickRow = (author: any) => {
        navigate(`/authors/${author.id}`);
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={{ base: '2xl', md: '3xl' }} fontWeight={"extrabold"}>Author</Heading>
                </Box>
                <Flex mt={3}>
                    <Button onClick={() => navigate('/authors/new')}>Buat Author Baru</Button>
                </Flex>
                <Box mt={4}>
                    <LogosTable
                        headers={[
                            { label: 'Nama' },
                            { label: 'Profesi' },
                            { label: 'Aktif?' }]}
                        rows={[
                            { propertyName: 'name' },
                            { propertyName: 'shortBioData' },
                            {
                                render: (item: any) => {
                                    return <Text fontWeight={'bold'} color={item.status == 0 ? "green" : "red"}>{item.status == 0 ? "Aktif" : "Tidak Aktif"}</Text>
                                }
                            }
                        ]}
                        data={authors}
                        onRowClick={handleClickRow}
                    />
                </Box>
            </Container>
        </Layout >
    );
};

export default AuthorScene;